import React, { useContext } from "react";
import { ProductImageGallery } from "./product-image-gallary";
import ProductDescription from "./product-description";
import ProductVariations from "./product-variations";
import ProductActions from "./product-actions";
import SocialShare from "./social-share";
import { AuthContext } from "../../contexts/AuthContext";

export default function CartSingleProduct({
  title,
  description,
  images,
  centimeter,
  inch,
  quantity,
  isSample,
  item,
}: {
  title: string;
  description: string;
  images: any[];
  centimeter: any;
  inch: any;
  quantity: number;
  isSample: boolean;
  item: any;
}) {
  const { user } = useContext(AuthContext);
  return (
    <section className="ec-page-content section-space-p">
      <div className="container">
        <div className="row">
          <div className="ec-pro-rightside ec-common-rightside col-lg-12 order-lg-last col-md-12 order-md-first">
            <div className="single-pro-block">
              <div className="single-pro-inner">
                <div className="row">
                  <ProductImageGallery images={images} isSample={isSample} />
                  <div className="single-pro-desc">
                    <div className="single-pro-content">
                      <ProductDescription
                        title={title}
                        description={description}
                      />
                      <div className="variable-single-item">
                        <span className="mb-0 mt-1">
                          Available Stock: {quantity}
                        </span>
                        <table className="w-25 table table-bordered">
                          <thead>
                            <tr>
                              <td>Dimensions</td>
                              <td>Length</td>
                              <td>Width</td>
                              <td>Height</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td scope="row">Centimeter</td>
                              <td>{centimeter.length}</td>
                              <td>{centimeter.width}</td>
                              <td>{centimeter.height}</td>
                            </tr>
                            <tr>
                              <td scope="row">Inches</td>
                              <td>{inch.length}</td>
                              <td>{inch.width}</td>
                              <td>{inch.height}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {/* <ProductVariations /> */}
                      {user.userType === "Buyer" ? (
                        <ProductActions item={item} quantity={quantity} />
                      ) : (
                        ""
                      )}

                      {/* <SocialShare /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <ProductTabs /> */}
          </div>
        </div>
      </div>
    </section>
  );
}
